/* Smartap handbook (sections/st-handbook.liquid): marks the text being read in "On this page".
   The rail (from 900px) and the chips (below) are plain anchor links; this adds aria-current
   ="location" to the link of the last text whose heading has passed the top of the reading area,
   and keeps the marked chip in view by scrolling the chip row sideways only (never the page).
   Without script, or before the first scroll, nothing is marked and every link still works. */
(() => {
  const init = (root) => {
    if (root.dataset.stHbReady) return;
    root.dataset.stHbReady = 'true';
    const links = [...root.querySelectorAll('[data-st-hb-link]')];
    // Only the texts the list names: an unlisted text (no menu label) keeps the last mark.
    const named = new Set(links.map((a) => a.getAttribute('href').slice(1)));
    const secs = [...root.querySelectorAll('[data-st-hb-sec][id]')].filter((s) => named.has(s.id));
    const row = root.querySelector('.st-hb__chips ul');
    if (!secs.length || !links.length) return;

    let current = '';
    const mark = (id) => {
      if (id === current) return;
      current = id;
      links.forEach((a) => {
        if (a.getAttribute('href') === `#${id}`) {
          a.setAttribute('aria-current', 'location');
          if (row && row.contains(a)) {
            const left = a.offsetLeft - (row.clientWidth - a.offsetWidth) / 2;
            row.scrollTo({ left: Math.max(0, left), behavior: 'auto' });
          }
        } else {
          a.removeAttribute('aria-current');
        }
      });
    };

    // The reading line sits a little under the sticky header and chips.
    const line = () => Math.round(window.innerHeight * 0.25);
    const update = () => {
      let id = '';
      for (const sec of secs) {
        if (sec.getBoundingClientRect().top <= line()) id = sec.id;
        else break;
      }
      if (id) mark(id);
    };
    let queued = false;
    const onScroll = () => {
      if (queued) return;
      queued = true;
      setTimeout(() => {
        queued = false;
        update();
      }, 100);
    };
    // Horizon scrolls .page-wrapper, not the window (base.css: html:has(.page-wrapper) is overflow:
    // hidden), and scroll events do not bubble, so listen on the document in the capture phase.
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  };

  const run = () => document.querySelectorAll('[data-st-hb]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
